var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:{ prependWithN: 'text-nowrap' },attrs:{"variant":"link"},on:{"click":_vm.onClick}},[(_vm.prependWithN)?_c('span',[_vm._v("№")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }